import account from "./modules/account";
import billing from "./modules/billing";

export default {
  account,
  billing
};
